<form [formGroup]="componentForm">
	<div class="row">
		<div class="col-lg-6">
			<div class="row mb-3" [attr.data-test-id]="'providerFormGroup'">
				<label class="col-md-3 col-lg-4 col-form-label required">Provider</label>
				<div class="col-md-9 col-lg-8">
					@if (providers) {
						<ejs-dropdownlist [dataSource]="providers"
										  pmsAutoSelect
										  placeholder="Select Provider"
										  formControlName="providerId"
										  [showClearButton]="true">
						</ejs-dropdownlist>
					}
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'salutationFormGroup'">
				<label class="col-md-3 col-lg-4 col-form-label">Salutation</label>
				<div class="col-md-9 col-lg-8">
					@if (titles) {
						<ejs-dropdownlist [dataSource]="titles"
										  placeholder="Select Salutation"
										  formControlName="titleId"
										  [showClearButton]="true">
						</ejs-dropdownlist>
					}
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'firstNameFormGroup'">
				<label class="col-md-3 col-lg-4 col-form-label required">First Name</label>
				<div class="col-md-9 col-lg-8">
					<input class="e-input" pmsCapitalizeFirstLetter type="text" formControlName="firstName"/>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'lastNameFormGroup'">
				<label class="col-md-3 col-lg-4 col-form-label required">Last Name</label>
				<div class="col-md-9 col-lg-8">
					<input class="e-input" pmsCapitalizeFirstLetter type="text" formControlName="lastName"/>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'middleNameFormGroup'">
				<label class="col-md-3 col-lg-4 col-form-label">Middle Name</label>
				<div class="col-md-9 col-lg-8">
					<input class="e-input" pmsCapitalizeFirstLetter type="text" formControlName="middleName"/>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="row mb-3" [attr.data-test-id]="'locationFormGroup'">
				<label class="col-form-label col-md-3 col-lg-4 required">Location</label>
				<div class="col-md-9 col-lg-8">
					<ejs-dropdownlist [dataSource]="locations"
									  formControlName="locationId"
									  [showClearButton]="true">
					</ejs-dropdownlist>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'suffixFormGroup'">
				<label class="col-12 col-md-3 col-lg-4 col-form-label">Suffix</label>
				<div class="col-7 col-md-4 col-lg-4">
					<input class="e-input" formControlName="suffix"/>
				</div>
				<div class="col-5 col-md-5 col-lg-4">
					<span class="form-text">(eg. Jr, Sr)</span>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'credentialsFormGroup'">
				<label class="col-12 col-md-3 col-lg-4 col-form-label">Cred.</label>
				<div class="col-7 col-md-4 col-lg-4">
					<input type="text" class="e-input" formControlName="credentials"/>
				</div>
				<div class="col-5 col-md-5 col-lg-4">
					<span class="form-text">(eg. OD, MD)</span>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'nicknameFormGroup'">
				<label class="col-md-3 col-lg-4 col-form-label">Nickname</label>
				<div class="col-md-9 col-lg-8">
					<input type="text" class="e-input" formControlName="nickname" pmsCapitalizeFirstLetter/>
				</div>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'pronunciationFormGroup'">
				<label class="col-md-3 col-lg-4 col-form-label">Pronunciation</label>
				<div class="col-md-9 col-lg-8">
					<input type="text" class="e-input" formControlName="pronunciation" pmsCapitalizeFirstLetter/>
				</div>
			</div>
		</div>
	</div>
</form>
